if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(`#Quantity-${this.dataset.section} input[name="quantity"]`);
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');

        // Biscuits bundles
        this.biscuitsBundleForm = this.querySelector('biscuits-bundle-form');
        if (this.biscuitsBundleForm) {
          this.initBiscuitsBundle();
        }
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      initBiscuitsBundle() {
        
        // === Update prices
        this.updateBiscuitsBundlePrices();

        // Observer on biscuits bundle change
        const observer = new MutationObserver((mutationList) => {
          for (const mutation of mutationList) {
            if (mutation.target && mutation.target.classList.contains('biscuits-bundle-form__total')) {
              this.updateBiscuitsBundlePrices();
            }
          }
        });
        observer.observe(this, { childList: true, subtree: true });
        
      }

      updateBiscuitsBundlePrices() {

        // Price
        const sourceTotalPrice = this.querySelector('[data-biscuits-form-total]');
        const destinationTotalPrices = this.querySelectorAll('.price .price__regular .price-item--regular, .price .price__sale .price-item--sale, [data-product-submit-btn-price]');
        if (sourceTotalPrice !== null && sourceTotalPrice !== undefined && destinationTotalPrices.length > 0) {
          destinationTotalPrices.forEach(destinationTotalPrice => {
            destinationTotalPrice.innerHTML = sourceTotalPrice.innerHTML;
          });
        }

        // Compare at price
        const sourceCompareAtPrice = this.querySelector('[data-biscuits-form-compare]');
        const destinationCompareAtPrices = this.querySelectorAll('.price .price__sale .price-item--regular, [data-product-submit-btn-compare-at-price]');
        if (sourceCompareAtPrice !== null && sourceCompareAtPrice !== undefined && destinationCompareAtPrices.length > 0) {
          destinationCompareAtPrices.forEach(destinationCompareAtPrice => {
            destinationCompareAtPrice.innerHTML = sourceCompareAtPrice.innerHTML;
          });
        }

        // Add ready class to body
        document.querySelector('body').classList.add('biscuits-bundle-ready');

      }
    }
  );
}
